import { Dropdown } from "antd";
import styled from "styled-components";

export const StyledDropdown = styled(Dropdown)`
  padding-right: ${({ pr }) => pr};
  padding-left: ${({ pl }) => pl};
`;
